import { Portal } from '@radix-ui/react-dialog';
import { useState } from 'react';
import { Dialog } from '~/shared/components/Dialog/Dialog';
import { DialogContent } from '~/shared/components/Dialog/DialogContent';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';
import { FacetsOverlayForm, FacetsOverlayFormProps } from './components/FacetsOverlayForm/FacetsOverlayForm';
import { FacetsOverlayTrigger } from './components/FacetsOverlayTrigger/FacetsOverlayTrigger';
import { StyledFacetsOverlay } from './styled';

export type FacetsOverlayProps = {
	form: FacetsOverlayFormProps;
	selectedFacetsCount?: number;
	showOnDesktop?: boolean;
};

export const FacetsOverlay = ({ form, selectedFacetsCount, showOnDesktop }: FacetsOverlayProps) => {
	const { translate } = useTranslation();
	const [isOpen, setOpen] = useState(false);

	const { onSubmit, ...formProps } = form;

	const handleSubmit = (): void => {
		onSubmit();
		setOpen(false);
	};

	return (
		<StyledFacetsOverlay showOnDesktop={showOnDesktop}>
			<Dialog
				open={isOpen}
				onOpenChange={setOpen}
			>
				<FacetsOverlayTrigger>
					{translate('filter.filter-button-label')}
					{selectedFacetsCount ? ` (${selectedFacetsCount})` : null}
				</FacetsOverlayTrigger>

				<Portal>
					<DialogContent side="left">
						<FacetsOverlayForm
							{...formProps}
							onSubmit={handleSubmit}
						/>
					</DialogContent>
				</Portal>
			</Dialog>
		</StyledFacetsOverlay>
	);
};
